import AjaxCart from '../helpers/AjaxCart'
class AddToCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._id = elem.getAttribute('data-add-to-cart')
    }
    onInit () {
        const elemHasClickEvent = this._elem.getAttribute('data-click-added')
        if (this._id && elemHasClickEvent == null) {
            this._elem.addEventListener('click', e => {
                this._elem.classList.add('working')
                this._addToCart()
                this._elem.classList.remove('working')
            })
            this._elem.setAttribute('data-click-added', 'true')
        }
    }
    async _addToCart () {
        const quantity = 1
        const selectedVariant = this._id
        const payload = {quantity, id: selectedVariant}
        await AjaxCart.addItem(payload)
    }
}

export default AddToCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/AddToCart.js